<template>
  <div
    class="header-box"
    :class="[
      `theme-${navTheme}`,
      { top500: navFixed || scrollTop > 100 },
      { wait: isWait },
    ]"
  >
    <div class="left">
      <div class="logo">
        <img
          src="@/assets/img/logo/logo.png"
          alt="赛博威"
          v-show="navFixed || scrollTop > 100 || navTheme === 'black'"
        />
        <img
          src="@/assets/img/logo/logo-w.png"
          alt="赛博威"
          v-show="!navFixed && scrollTop < 100 && navTheme === 'white'"
        />
      </div>
      <div :class="{ selected: selected === 'home' }" @click="toPage('home')">
        <span>首页</span>
        <span class="line"></span>
      </div>
      <div :class="{ selected: selected === 'products' }">
        <span>产品服务</span>
        <span class="line"></span>
        <div
          class="hover-box product"
          :class="{ top500: navFixed || scrollTop > 100 }"
        >
          <div class="blank"></div>
          <div class="backdrop-filter">
            <div class="lists">
              <div class="list">
                <div class="left">
                  <span class="text">
                    数字营销咨询服务
                    <span class="img">
                      <img
                        v-lazy="
                          require('@/assets/img/industrySolutions/next-b.png')
                        "
                        alt="数字营销咨询服务"
                      />
                    </span>
                  </span>
                </div>
                <div class="right-text">
                  <div class="right-text-item">
                    <div @click="toPage('/products/cyber-insight')">
                      <img
                        v-lazy="require('@/assets/img/header/item-14.png')"
                        alt="数字营销专业咨询伙伴"
                      />
                      <span>数字营销专业咨询伙伴</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="line"></div>
              <div class="list">
                <div class="left">
                  <span class="text">
                    数字营销3A模型
                    <span class="img">
                      <img
                        v-lazy="
                          require('@/assets/img/industrySolutions/next-b.png')
                        "
                        alt="Application"
                      />
                    </span>
                  </span>
                </div>
                <div class="right-text">
                  <div class="right-text-title">Application</div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/cyber-tpm')">
                      <img
                        v-lazy="require('@/assets/img/header/item-1.png')"
                        alt="高阶数智化营销费用管理（Cyber TPM）"
                      />
                      <span>高阶数智化营销费用管理（Cyber TPM）</span>
                    </div>
                  </div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/tpm+')">
                      <img
                        v-lazy="require('@/assets/img/header/item-2.png')"
                        alt="营销费用管理 Plus（TPM +）"
                      />
                      <span>营销费用管理 Plus（TPM +）</span>
                    </div>
                  </div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/b2b')">
                      <img
                        v-lazy="require('@/assets/img/header/item-5.png')"
                        alt="智能订货协同平台（B2B）"
                      />
                      <span>智能订货协同平台（B2B）</span>
                    </div>
                  </div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/sfa')">
                      <img
                        v-lazy="require('@/assets/img/header/item-3.png')"
                        alt="销售能力自动化（SFA）"
                      />
                      <span>销售能力自动化（SFA)</span>
                    </div>
                  </div>
                  <div class="right-text-title mt-20">Analytics</div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/mdm')">
                      <img
                        v-lazy="require('@/assets/img/header/item-9.png')"
                        alt="主数据管理（MDM）"
                      />
                      <span>主数据管理（MDM）</span>
                    </div>
                  </div>
                  <div class="right-text-item" @click="toPage('/products/bi')">
                    <div>
                      <img
                        v-lazy="require('@/assets/img/header/item-8.png')"
                        alt="全域商业洞察（BI）"
                      />
                      <span>全域商业洞察（BI）</span>
                    </div>
                  </div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/npi')">
                      <img
                        v-lazy="require('@/assets/img/header/item-6.png')"
                        alt="新品研发 · 协同平台"
                      />
                      <span>新品研发 · 协同平台</span>
                    </div>
                  </div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/coi')">
                      <img
                        v-lazy="require('@/assets/img/header/item-7.png')"
                        alt="消费者意见洞察"
                      />
                      <span>消费者意见洞察</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="line"></div>
              <div class="list">
                <div class="left">
                  <span class="text">
                    数字营销一体化系统运维
                    <span class="img">
                      <img
                        v-lazy="
                          require('@/assets/img/industrySolutions/next-b.png')
                        "
                        alt="数字化运维"
                      />
                    </span>
                  </span>
                </div>
                <div class="right-text">
                  <div class="right-text-item">
                    <div @click="toPage('/products/som')">
                      <img
                        v-lazy="require('@/assets/img/header/item-13.png')"
                        alt="系统运维"
                      />
                      <span>系统运维</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="line"></div>
              <div class="list">
                <div class="left">
                  <span class="text">
                    地产石化
                    <span class="img">
                      <img
                        v-lazy="
                          require('@/assets/img/industrySolutions/next-b.png')
                        "
                        alt="地产石化"
                      />
                    </span>
                  </span>
                </div>
                <div class="right-text">
                  <div class="right-text-item">
                    <div @click="toPage('/products/ic')">
                      <img
                        v-lazy="require('@/assets/img/header/item-10.png')"
                        alt="智慧物业管理"
                      />
                      <span>智慧物业管理</span>
                    </div>
                  </div>
                  <div class="right-text-item">
                    <div @click="toPage('/products/sp')">
                      <img
                        v-lazy="require('@/assets/img/header/item-12.png')"
                        alt="智慧石化"
                      />
                      <span>智慧石化</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="{ selected: selected === 'capabilities' }"
        @click="toPage('capabilities')"
      >
        <span>数字化能力</span>
        <span class="line"></span>
      </div>
      <div
        :class="{ selected: selected === 'scheme' }"
        @click="toPage('scheme')"
      >
        <span>行业解决方案</span>
        <span class="line"></span>
      </div>
      <div :class="{ selected: selected === 'goIn' }">
        <span>走进Cyberway</span>
        <span class="line"></span>
        <div
          class="hover-box go-in"
          :class="{ top500: navFixed || scrollTop > 100 }"
        >
          <div class="blank"></div>
          <div class="backdrop-filter">
            <div class="lists">
              <div class="list" @click="toPage('/goin/about')">
                <span class="text">
                  关于赛博威
                  <span class="img">
                    <img
                      v-lazy="
                        require('@/assets/img/industrySolutions/next-b.png')
                      "
                      alt="关于赛博威"
                    />
                  </span>
                </span>
              </div>
              <div class="list" @click="toPage('/goin/news')">
                <span class="text">
                  品牌资讯
                  <span class="img">
                    <img
                      v-lazy="
                        require('@/assets/img/industrySolutions/next-b.png')
                      "
                      alt="品牌资讯"
                    />
                  </span>
                </span>
              </div>
              <div class="list" @click="toPage('/goin/join-us')">
                <span class="text">
                  加入我们
                  <span class="img">
                    <img
                      v-lazy="
                        require('@/assets/img/industrySolutions/next-b.png')
                      "
                      alt="加入我们"
                    />
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <span class="circle">
        <img v-lazy="require('@/assets/img/top-tel.png')" alt="tel" />
      </span>
      <span>400-168-0262</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "newHeader",
  computed: {
    ...mapGetters(["navTheme", "navFixed"]),
  },
  data() {
    return {
      scrollTop: 0,
      selected: "home",
      isWait: true, // 顶部等待三秒再出现
    };
  },
  watch: {
    $route(to, from) {
      // navThemeCustom 设置时在组件内部处理
      if (!(to.meta && to.meta.navThemeCustom)) {
        this.$store.dispatch(
          "setNavTheme",
          (to.meta && to.meta.navTheme) || "white"
        );
      }

      // 顶部栏是否固定 - 默认不固定
      console.log("navFixed", to.meta && to.meta.navFixed);
      this.$store.dispatch(
        "setNavFixed",
        (to.meta && to.meta.navFixed) || false
      );

      this.init();
    },
  },
  methods: {
    init() {
      const { pathname } = location;
      console.log("path", location);
      if (pathname.includes("home")) {
        this.selected = "home";
      } else if (pathname.includes("products")) {
        this.selected = "products";
      } else if (pathname.includes("capabilities")) {
        this.selected = "capabilities";
      } else if (pathname.includes("solutions")) {
        this.selected = "scheme";
      } else if (pathname.includes("goin")) {
        this.selected = "goIn";
      }
    },
    doScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop)
      this.scrollTop = scrollTop;
    },
    toPage(value) {
      this.selected = value;
      switch (value) {
        case "home":
          this.$router.push("/");
          break;
        case "scheme":
          this.$router.push("/solutions");
          break;
        case "capabilities":
          this.$router.push("/capabilities");
          break;
        default:
          console.log("default", value);
          this.$router.push(value);
          break;
      }

      // 将 class 为 hover-box 的元素 hover
      const hoverBox = document.getElementsByClassName("hover-box");
      for (let i = 0; i < hoverBox.length; i++) {
        hoverBox[i].style.display = "none";
      }
      const timer = setTimeout(() => {
        clearTimeout(timer);
        // 移除 style
        for (let i = 0; i < hoverBox.length; i++) {
          hoverBox[i].removeAttribute("style");
        }
      }, 16);
    },
  },
  created() {
    window.addEventListener("scroll", this.doScroll);

    const timer = setTimeout(() => {
      this.isWait = false;
      clearTimeout(timer);
    }, 3000);
  },
  mounted() {
    this.init();
    console.log(this.navTheme);
  },
};
</script>

<style lang="scss" scoped>
.header-box {
  height: 110px;
  width: 100%;
  position: fixed;
  z-index: 99;
  padding: 58px 165px 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &.top500 {
    color: #383d44 !important;
    background-color: #fff;
    animation: fade-in 0.6s ease;
  }

  &.theme-white {
    color: #ffffff;
  }

  &.theme-black {
    color: #383d44;
  }

  .left {
    display: flex;
    align-items: center;

    > div {
      margin-right: 81px;
      font-size: 17px;
      font-family: "MiSans-Normal-";
      line-height: 52px;
      cursor: pointer;
      position: relative;

      &:hover {
        position: relative;
        > span {
          font-family: "MiSans-Bold-";
          color: #1d56de;
        }
        .line {
          position: absolute;
          height: 2px;
          width: 79px;
          background-color: #005fe6;
          bottom: 0px;
          left: 50%;
          transform: translateX(-50%);
        }
        .hover-box {
          display: block;
          animation: fade-in 0.2s;
        }
      }

      .hover-box {
        top: 52px;
        left: 50%;
        transform: translateX(-50%);
        width: 204px;
        position: absolute;
        display: none;
        cursor: default;

        &.top500 {
          .backdrop-filter {
            backdrop-filter: blur(2px);
          }
          .lists {
            opacity: 0.9;
          }
        }

        &.product {
          width: 1121px;
          left: -50px;
          transform: none;

          .backdrop-filter {
            border-radius: 22px;
            overflow: hidden;
            box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.15);
          }
          .lists {
            padding: 30px 0;

            .line {
              width: 1018px;
              height: 1px;
              opacity: 1;
              background-color: #c1c1c1;
              position: relative;
            }

            .list {
              font-size: 19px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              height: auto;
              padding: 14px 0 10px;

              .left {
                width: 388px;
                height: 40px;
                line-height: 40px;
                flex-grow: 0;
                flex-shrink: 0;

                .text {
                  padding-left: 50px;
                  margin-left: 0;
                  margin-top: -5px;
                  font-family: "MiSans-Semibold-";
                  line-height: 28px;
                }
              }

              .right-text {
                flex-grow: 1;
                display: flex;
                flex-wrap: wrap;
                .right-text-title {
                  width: 100%;
                  font-size: 20px;
                  font-family: "MiSans-Demibold-";
                  line-height: 28px;
                  color: #00094c;
                  margin-bottom: 16px;
                }
                .mt-20 {
                  margin-top: 25px;
                }
                .right-text-item {
                  width: 50%;
                  line-height: 40px;
                  height: 40px;
                  font-size: 17px;
                  font-family: "MiSans-Normal-";
                  line-height: 28px;
                  color: #686868;
                  display: flex;
                  align-items: center;
                  cursor: default;
                  > div {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    height: 20px;
                    line-height: 20px;

                    span {
                      height: 20px;
                      line-height: 20px;
                    }

                    &:hover {
                      font-family: "MiSans-Demibold-";
                      color: #1d56de;
                    }
                  }

                  .disabled {
                    cursor: not-allowed;
                    color: #c1c1c1;
                    &:hover {
                      color: #c1c1c1;
                      font-family: "MiSans-Normal-";
                    }
                  }

                  img {
                    width: 16px;
                    height: 17px;
                    margin-right: 8px;
                  }
                }

                .w-large {
                  width: 66.66%;
                }
              }
            }

            .list-large {
              height: 74px;
            }
          }
        }
        &.go-in {
          .backdrop-filter {
            border-radius: 22px;
            overflow: hidden;
            box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.15);
          }

          .lists {
            .text {
              cursor: pointer;
            }
          }
        }
        .blank {
          height: 22px;
          width: 100%;
        }
        .lists {
          padding: 8px 0;
          background-color: #fff;
          border-radius: 7px;
        }
        .list {
          display: flex;
          height: 47px;
          align-items: center;
          font-size: 17px;
          justify-content: center;

          &:hover {
            background: linear-gradient(
              to right,
              #f0f3ffff,
              #f0f3fff5,
              #f2f4ffd9,
              #f5f7ffab,
              #f8faff6b,
              #fdfdff1a,
              #ffffff00
            );
            .text {
              font-family: "MiSans-Demibold-";
              color: #1d56de;
            }
            .img {
              visibility: visible;
            }
          }

          .text {
            font-family: "MiSans-Regular-";
            color: #000;
            position: relative;
          }

          .img {
            visibility: hidden;
            position: absolute;
            right: -40px;
            top: 50%;
            transform: translateY(-56%);
          }
          img {
            width: 9px;
            height: 15px;
          }
        }
      }
      &.selected {
        font-family: "MiSans-Bold-";
        color: #1d56de;
        position: relative;

        .line {
          position: absolute;
          height: 2px;
          width: 79px;
          background-color: #005fe6;
          bottom: 0px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }

    .logo {
      img {
        width: 153px;
        height: 50px;
      }
    }
  }
  .right {
    font-size: 28px;
    font-family: "MiSans-Demibold-";
    color: #1d56de;
    display: flex;
    align-items: center;

    .circle {
      width: 31px;
      height: 31px;
      border-radius: 50%;
      margin-right: 14px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.wait {
  animation: wait-in 3s ease;
}

/* 定义动画 */
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes wait-in {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewHeader.vue